import useToken from 'hooks/useToken';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import { useToast } from 'context/providers/ToastProvider';
/**
 * Componente para la sección de Datos Fiscales del Emisor y Cliente
 * Soporta caracteres Unicode (acentos, ñ, símbolos especiales)
 */
const DatosFiscalesEmisor = ({
    cargandoForm,
    errors,
    clearError,

    // Props de datos fiscales del cliente
    register,
    selectedValues,
    setSelectedValues,
    isForeignRFC,
    handleRFCChange,
    setValue
}) => {
    const { token, setToken } = useToken();

    const [regimenesFiscales, setRegimenesFiscales] = useState([])
    const [paises, setPaises] = useState([]);
    const [usoCFDI, setUsoCFDI] = useState([]);
    const { showErrorToast } = useToast();
    /**
     * Obtiene los Regimenes Fiscales
     */
    const ObtenerRegimenesFiscales = async () => {

        const response = await fetch("/api/Facturas/ObtenerRegimenesFiscales",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                // console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            // console.log("==== OBTENER REGIMENES FISCALES ====");

            // console.log("response: ", response);
            const data = await response.json();
            // console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //   console.log("ObjDetallesRF:", ObjDetalles);

                setRegimenesFiscales(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
    * Obtiene Uso CFDI
    */
    const ObtenerUsoCFDI = async () => {

        const response = await fetch("/api/Facturas/ObtenerUsoCFDI",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("==== OBTENER USO CFDI ====");

            //console.log("response: ", response);
            const data = await response.json();
            // console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesCFDI:", ObjDetalles);

                setUsoCFDI(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }

    /**
   * Obtiene los paises del Cat Sat
   */
    const ObtenerCatPaises = async () => {
        if (paises.length > 0) return; // Ya están cargadas

        const response = await fetch("/api/Facturas/ObtenerCatPaises",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            })
            .catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                //console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            //console.log("==== OBTENER PAIS ====");

            //console.log("response: ", response);
            const data = await response.json();
            //console.log("dataRF: ", data);

            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);

                //console.log("ObjDetallesPais:", ObjDetalles);

                setPaises(ObjDetalles.table2);


            } else {
                showErrorToast(data.vMessage);
            }

        }
        else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    }


    useEffect(() => {
        ObtenerRegimenesFiscales();
        ObtenerUsoCFDI();
        ObtenerCatPaises();
    }, []);

    return (
        <>
            <h5 className="mt-3">Datos Fiscales del Cliente</h5>
            <Row>
                <Col xs={12} lg={12} className="mb-2">
                    {/* Razón Social */}
                    <Form.Label>Raz&oacute;n Social</Form.Label>
                    {
                        cargandoForm ?
                            <Skeleton />
                            : <Form.Control
                                size="sm"
                                autoComplete="off"
                                type="text"
                                defaultValue=""
                                onKeyUp={(event) => { event.target.value = event.target.value.toUpperCase() }}
                                isInvalid={!!errors.vRazonSocial}
                                {...register('vRazonSocial',
                                    {
                                        required: 'La Raz\u00f3n Social es obligatoria',
                                        maxLength: 300,
                                        minLength: 1,
                                        pattern: /[^|]{1,300}/
                                    })
                                }
                                onChange={(e) => {
                                    if (e.target.value) {
                                        clearError("vRazonSocial");
                                    }
                                }}
                            />
                    }
                    {errors.vRazonSocial && (
                        <Form.Text className="text-danger">{errors.vRazonSocial}</Form.Text>
                    )}
                </Col>
            </Row>

            <Row>
                <Col xs={6} lg={6}>
                    {/* RFC */}
                    <Form.Group className="mb-2">
                        <Form.Label>RFC</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    autoComplete="off"
                                    {...register("vRFC", {
                                        pattern: {
                                            value: /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/,
                                            message: "El RFC no tiene un formato v\u00e1lido",
                                        },
                                    })}
                                    onChange={(e) => {
                                        handleRFCChange(e.target.value)
                                        if (e.target.value) {
                                            clearError("vRFC");
                                        }
                                    }}
                                    isInvalid={!!errors.vRFC}
                                />

                        }
                        {errors.vRFC && (
                            <Form.Text className="text-danger">{errors.vRFC}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
                <Col xs={6} lg={6}>
                    <Form.Group>
                        <Form.Label>C&oacute;digo Postal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control
                                    size="sm"
                                    type="text"
                                    inputMode="numeric"
                                    autoComplete="off"
                                    maxLength={5}
                                    {...register("vCP", {
                                        required: "El c\u00f3digo postal es obligatorio",
                                        pattern: { value: /^\d{5}$/, message: "Formato no v\u00e1lido (5 d\u00edgitos)" },
                                    })}
                                    onChange={(e) => {
                                        let valor = e.target.value.replace(/\D/g, ""); // Elimina caracteres no numéricos
                                        setValue("vCP", valor);
                                        if (valor) {
                                            clearError("vCP"); // Limpia errores si se ingresa algo
                                        }
                                    }}
                                    onBlur={(e) => {
                                        let valorIngresado = e.target.value.trim();
                                        if (valorIngresado === register("vCP").value) {
                                            return;
                                        }
                                        // setValue("vCP", valorIngresado); // ✅ Asegura que React Hook Form actualiza el valor
                                        // trigger("vCP"); // ✅ Dispara la validación en tiempo real
                                        clearError("vCP");
                                    }}
                                    isInvalid={!!errors.vCP}
                                />
                        }
                        {errors.vCP && (
                            <Form.Text className="text-danger">{errors.vCP}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Campos adicionales para RFC extranjero */}
            {isForeignRFC && (
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>Pa&iacute;s de Residencia</Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Select
                                        size="sm"
                                        {...register("vPaisFacturacion", { required: isForeignRFC ? "El país es requerido" : false })}
                                        onChange={(e) => {
                                            setValue("vPaisFacturacion", e.target.value);
                                            setSelectedValues((prev) => ({ ...prev, vPaisFacturacion: e.target.value }));
                                            if (e.target.value) {
                                                clearError("vPaisFacturacion");
                                            }
                                        }}
                                        value={selectedValues.vPaisFacturacion}
                                        isInvalid={!!errors.vPaisFacturacion}
                                    >
                                        <option value="">Seleccione un Pa&iacute;s</option>
                                        {paises.map((name, index) => (
                                            <option key={index} value={name.cShortName}>
                                                {name.cShortName} - {name.vName}
                                            </option>
                                        ))}
                                    </Form.Select>
                            }
                            {errors.vPaisFacturacion && (
                                <Form.Text className="text-danger">{errors.vPaisFacturacion}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                    <Col className="mb-2">
                        <Form.Group>
                            <Form.Label>N&uacute;m. Registro Tributario</Form.Label>
                            {
                                cargandoForm ?
                                    <Skeleton />
                                    :
                                    <Form.Control
                                        size="sm"
                                        type="text"
                                        {...register("vNumRT", {
                                            //required: isForeignRFC ? "El campo NumRT es requerido" : false,
                                            maxLength: { value: 20, message: "El NumRT no puede superar los 20 caracteres" },
                                        })}
                                        onChange={(e) => {
                                            if (e.target.value) {
                                                clearError("vNumRT");
                                            }
                                        }}
                                        isInvalid={!!errors.vNumRT}
                                    />
                            }
                            {errors.vNumRT && (
                                <Form.Text className="text-danger">{errors.vNumRT}</Form.Text>
                            )}
                        </Form.Group>
                    </Col>
                </Row>
            )}

            <Row>
                <Col xs={6} md={6}>
                    {/* Régimen Fiscal */}
                    <Form.Group className="mb-3">
                        <Form.Label>R&eacute;gimen Fiscal</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select
                                    size="sm"
                                    isInvalid={!!errors.vCodigoRegimen}
                                    value={selectedValues.vCodigoRegimen || ""}
                                    onChange={(e) => {
                                        setSelectedValues((prev) => ({ ...prev, vCodigoRegimen: e.target.value }));
                                        if (e.target.value) {
                                            clearError("vCodigoRegimen");
                                        }
                                    }}                            >
                                    <option value="">Selecciona un r&eacute;gimen</option>
                                    {regimenesFiscales.map((regimen, index) => (
                                        <option key={index} value={regimen.vCodigoRegimen}>
                                            {regimen.vCodigoRegimen} - {regimen.vDescripcionRegimenFiscal}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoRegimen && (
                            <Form.Text className="text-danger">{errors.vCodigoRegimen}</Form.Text>
                        )}
                    </Form.Group>
                </Col>

                <Col xs={6} md={6}>
                    <Form.Group>
                        <Form.Label>Uso CFDI</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Select
                                    size="sm"
                                    value={selectedValues.vCodigoUso || ""}
                                    onChange={(e) => {
                                        setSelectedValues((prev) => ({ ...prev, vCodigoUso: e.target.value }));
                                        if (e.target.value) {
                                            clearError("vCodigoUso");
                                        }
                                    }}
                                    isInvalid={!!errors.vCodigoUso}
                                >
                                    <option value="">Seleccione un Uso CFDI</option>
                                    {usoCFDI.map((cfdi, index) => (
                                        <option key={index} value={cfdi.vCodigoUso}>
                                            {cfdi.vCodigoUso} - {cfdi.vDescripcionUsoCFDI}
                                        </option>
                                    ))}
                                </Form.Select>
                        }
                        {errors.vCodigoUso && (
                            <Form.Text className="text-danger">{errors.vCodigoUso}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>

            {/* Email */}
            <Row>
                <Col xs={12} lg={12}>
                    <Form.Group>
                        <Form.Label>Email</Form.Label>
                        {
                            cargandoForm ?
                                <Skeleton />
                                :
                                <Form.Control
                                    size="sm"
                                    type="email"
                                    autoComplete="off"
                                    isInvalid={!!errors.vEmail}
                                    {...register("vEmail", {
                                        pattern: {
                                            value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                                            message: "Formato de correo no v\u00e1lido",
                                        },
                                    })}
                                />
                        }
                        {errors.vEmail && (
                            <Form.Text className="text-danger">{errors.vEmail}</Form.Text>
                        )}
                    </Form.Group>
                </Col>
            </Row>
        </>
    );
};

DatosFiscalesEmisor.propTypes = {
    // Props del emisor
    cargandoForm: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    clearError: PropTypes.func.isRequired,

    // Props de datos fiscales del cliente
    register: PropTypes.func.isRequired,
    selectedValues: PropTypes.object.isRequired,
    setSelectedValues: PropTypes.func.isRequired,
    isForeignRFC: PropTypes.bool.isRequired,
    handleRFCChange: PropTypes.func.isRequired,
    setValue: PropTypes.func.isRequired
};

export default DatosFiscalesEmisor;